export const convertToUTC = (date) => new Date(date).toISOString().substring(0, 19).replace('T', ' ')
